export default "__VITE_ASSET__DBy4rHwq__"